import Cookies from "js-cookie";

const isValidUser = () => {
  const token = Cookies.get("jweToken");
  return !!token;
};

export { isValidUser };

export const getAuthToken = () => {
  return Cookies.get("jweToken") || "";
};

export const removeToken = () => {
  Cookies.remove("jweToken", { path: "/" });
};
